import type {
  CreateServiceFeeConfigParams,
  QueryAgencyAdsAccountList,
  QueryAgencyAdsAccountParams,
  ServiceFeeConfigList,
  ServiceFeeConfigListParams,
} from './types'

import type { PagingRequest } from '#/api/type'

import { defineApi } from '#/api/define-api'
import { requestClient } from '#/api/request'

export const serviceFeeConfigApi = defineApi('operation', ({ prefix }) => {
  function getServiceFeeConfigListParams(
    params: PagingRequest<ServiceFeeConfigListParams>,
  ) {
    return {
      agency: params.condition.agency,
      accountId: params.condition.accountId,
      accountName: params.condition.accountName,
      rateStatus: Number(params.condition.rateStatus),
      mediaPlatform: params.condition.mediaPlatform,
    }
  }

  function getServiceFeeConfigList(
    params: PagingRequest<ServiceFeeConfigListParams>,
  ) {
    params = {
      pageIndex: params.pageIndex,
      pageSize: params.pageSize,
      condition: getServiceFeeConfigListParams(params),
    }

    // /gobestads/operation/adsAccount/queryAdsAccountRate
    return requestClient
      .post(prefix('adsAccount/queryAdsAccountRate'), params)
      .then((res) => {
        return {
          items:
            res?.list?.map((item: ServiceFeeConfigList) => ({
              id: item.id,
              accountId: item.accountId,
              accountName: item.accountName,
              agency: item.agency,
              rate: item.rate,
              rateStatus: String(item.rateStatus),
              mediaPlatform: item.mediaPlatform,
              createdBy: item.createdBy,
              createdTime: item.createdTime,
              updatedBy: item.updatedBy,
              updatedTime: item.updatedTime,
              agencyRate: item.agencyRate,
            })) || [],
          total: res?.total || 0,
        }
      })
  }

  // /gobestads/operation/adsAccount/createAdsAccountRate
  function createServiceFeeConfig(params: CreateServiceFeeConfigParams) {
    return requestClient.post(prefix('adsAccount/createAdsAccountRate'), {
      ids: params.ids,
      rate: Number(params.rate),
      rateStatus: Number(params.rateStatus),
    })
  }

  // /gobestads/operation/adsAccount/updateAdsAccountRate
  function updateServiceFeeConfig(params: CreateServiceFeeConfigParams) {
    return requestClient.post(prefix('adsAccount/updateAdsAccountRate'), {
      ids: params.ids,
      rate: Number(params.rate),
      rateStatus: Number(params.rateStatus),
    })
  }

  function queryAgencyAdsAccount(
    params: PagingRequest<QueryAgencyAdsAccountParams>,
  ) {
    // params = {
    //   ...params,
    //   condition: {
    //     account: params.condition.account,
    //   },
    // }
    return requestClient
      .post(prefix('adsAccount/queryAgencyAdsAccount'), params)
      .then((res) => {
        return {
          items:
            res?.list.map((item: QueryAgencyAdsAccountList) => ({
              id: String(item.id),
              accountId: item.accountId,
              accountName: item.accountName,
              isOper: item.isOper,
              mediaPlatform: item.mediaPlatform,
            })) || [],
          total: res?.total || 0,
        }
      })
  }

  return {
    getServiceFeeConfigList,
    createServiceFeeConfig,
    updateServiceFeeConfig,
    queryAgencyAdsAccount,
    getServiceFeeConfigListParams,
  }
})
